<template>
  <div id="athleteRegistrationPrint" style="display:none">
    <div class="first_registration" style="width:100%;border:1px solid #979797">
      <div class="regist_info">
        <h1 style="line-height:44px;text-align:center;font-size:24px;color:#222;">运动员注册页</h1>
        <!-- 运动员基本信息 -->
        <div class="basic_information" style="display: flex;border-top:1px solid #979797">
          <div
            class="info_left"
            style="width: 104px;border-right: 1px solid #979797;display: flex;align-items: center;justify-content: center;"
          >
            <p style="line-height: 24px;width: 24px;font-size: 20px;text-align: center;">运动员基本信息</p>
          </div>
          <div class="info_right" style="flex:1;display:flex;padding:20px 40px 20px 20px">
            <div class="left_info" style="flex:1">
              <div style="display:flex;">
                <ul style="min-width:65%;">
                  <li>
                    <p class="rows" style="display:flex;align-items:center">
                      <span class="row_title">中文姓名：</span>
                      <span>{{formInfo.name}}</span>
                    </p>
                  </li>
                  <li>
                    <p class="rows">
                      <span class="row_title">汉语拼音：</span>
                      <span>{{formInfo.nameSpell}}</span>
                    </p>
                  </li>
                  <li>
                    <p class="rows">
                      <span class="row_title">政治面貌：</span>
                      <span>{{getPolitical}}</span>
                    </p>
                  </li>
                  <li>
                    <p class="rows">
                      <span class="row_title">出生年月：</span>
                      <span>{{formInfo.birthday}}</span>
                    </p>
                  </li>
                  <li>
                    <p class="rows">
                      <span class="row_title">移动电话：</span>
                      <span>{{formInfo.phone}}</span>
                    </p>
                  </li>
                  <li>
                    <p class="rows">
                      <span class="row_title">身份证号码：</span>
                      <span>{{formInfo.idCard}}</span>
                    </p>
                  </li>
                </ul>
                <ul>
                  <li>民族：{{formInfo.nation}}</li>
                  <li>性别：{{formInfo.gender === 0?'女':'男'}}</li>
                  <li>身高：{{formInfo.height}}cm</li>
                  <li>体重：{{formInfo.weight}}kg</li>
                  <li>血型：{{getBloodType}}</li>
                  <li>鞋码：{{formInfo.shoesSize?formInfo.shoesSize + '码':''}}</li>
                </ul>
              </div>
              <ul style="width:95%;">
                <li>
                  <p class="rows">
                    <span class="row_title">运动员等级：</span>
                    <span>{{formInfo.athleteRank}}</span>
                  </p>
                </li>
                <li style="margin-bottom:0">
                  <p class="rows">
                    <span class="row_title">本人最好成绩：</span>
                    <span>{{formInfo.bestScore}}</span>
                  </p>
                </li>
              </ul>
            </div>
            <div class="user_image">
              <img style="width:200px;height:250px;" :src="formInfo.headImage" alt />
            </div>
          </div>
        </div>
        <!-- 学籍信息 -->
        <div class="student_status">
          <div class="info_left">
            <p>学籍信息</p>
          </div>
          <div
            class="info_right"
            style="flex:1;display:flex;align-items:center;padding:20px 40px 20px 0px"
          >
            <div class="left_info" style="flex:1;display:flex;">
              <ul style="min-width:45%;">
                <li>
                  <p class="rows">
                    <span class="row_title">就读学校：</span>
                    <span>{{formInfo.schoolName}}</span>
                  </p>
                </li>
                <li>
                  <p class="rows">
                    <span class="row_title">入学时间：</span>
                    <span>{{formInfo.startSchoolDate}}</span>
                  </p>
                </li>
                <li>
                  <p class="rows">
                    <span class="row_title">就读专业：</span>
                    <span>{{formInfo.major}}</span>
                  </p>
                </li>
                <li style="margin-bottom:0">
                  <p class="rows">
                    <span class="row_title">学生证号码：</span>
                    <span>{{formInfo.studentNumber}}</span>
                  </p>
                </li>
              </ul>
              <ul style="width:40%">
                <li>
                  <p class="rows">
                    <span class="row_title" style="width:100px">学校编号：</span>
                    <span>{{getSchoolCode}}</span>
                  </p>
                </li>
                <li>
                  <p class="rows">
                    <span class="row_title" style="width:100px">入学性质：</span>
                    <span>{{getSportsLevel}}</span>
                  </p>
                </li>
                <li>
                  <section class="rows">
                    <p
                      class="row_title"
                      style="width:100px;padding-left:20px;display:flex;justify-content:space-between;box-sizing:border-box"
                    >
                      <span>学</span>
                      <span>制：</span>
                    </p>
                    <span>{{getEducationalList}}</span>
                  </section>
                </li>
                <li style="margin-bottom:0">
                  <p class="rows">
                    <span class="row_title" style="width:100px">原毕业学校：</span>
                    <span>{{formInfo.sourceSchool}}</span>
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!-- 注册组别 -->
        <div class="regist_group">
          <div class="info_left">
            <p>注册组别</p>
          </div>
          <div
            class="info_right"
            style="flex:1;display:flex;align-items:center;padding:20px 40px 20px 0px"
          >
            <div class="left_info" style="flex:1;display:flex;">
              <ul style="min-width:45%;">
                <li>
                  <p class="rows">
                    <span class="row_title">注册类别：</span>
                    <span>{{formInfo.type === 1?'阳光项目':'竞技项目'}}</span>
                  </p>
                </li>
                <li>
                  <p class="rows">
                    <span class="row_title">注册组别：</span>
                    <span>{{getGroup}}</span>
                  </p>
                </li>
                <li style="margin-bottom:0">
                  <p class="rows">
                    <span class="row_title">注册项目：</span>
                    <span>{{getProjectNew(formInfo.projectNew)}}</span>
                  </p>
                </li>
              </ul>
              <ul style="width:40%">
                <li>
                  <p class="rows">
                    <span class="row_title">注册证号码：</span>
                    <span>{{formInfo.registerNumber}}</span>
                  </p>
                </li>
                <li>
                  <p class="rows">
                    <span class="row_title">首次注册项目：</span>
                    <span>{{getProjectNew(formInfo.projectFirst)}}</span>
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!-- 相关联系 -->
        <div class="related_links">
          <div class="info_left">
            <p>相关联系</p>
          </div>
          <div class="info_right" style="flex:1;display:flex;padding:20px 40px 20px 0px">
            <div class="left_info" style="flex:1">
              <div style="display:flex;">
                <ul style="min-width:45%;">
                  <li>
                    <p class="rows" style="display:flex;align-items:center">
                      <span class="row_title">教练员：</span>
                      <span>{{getCoachName}}</span>
                    </p>
                  </li>
                  <li>
                    <p class="rows">
                      <span class="row_title">应急联系人：</span>
                      <span>{{formInfo.urgentName}}</span>
                    </p>
                  </li>
                </ul>
                <ul style="width:40%">
                  <li>
                    <p class="rows" style="display:flex;align-items:center">
                      <span class="row_title">教练员电话：</span>
                      <span>{{getCoachPhone}}</span>
                    </p>
                  </li>
                  <li>
                    <p class="rows">
                      <span class="row_title">联系电话：</span>
                      <span>{{formInfo.urgentPhone}}</span>
                    </p>
                  </li>
                </ul>
              </div>
              <ul style="width:95%;">
                <li style="margin-bottom:0">
                  <p class="rows">
                    <span class="row_title">应急人地址：</span>
                    <span>{{formInfo.urgentAddress}}</span>
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!-- 备注 -->
        <div class="remark">
          <div class="info_left">
            <p>备注</p>
          </div>
          <div
            class="info_right"
            style="flex:1;display:flex;flex-direction:column;"
            :style="{padding:'30px 40px 30px 20px'}"
          >
            <p>{{!formInfo.remarks?'无':formInfo.remarks}}</p>
            <div>
              <img
                style="width:100px;height:100px;margin:0 20px 0 0"
                v-for="(item,index) in formInfo.remarksImageList"
                :style="{marginTop:index <= 5?'20px':'0'
                ,marginRight:index === 5?0:'20px',marginBottom:formInfo.remarksImageList.length < 6?'0':index > 5?'0':'20px'}"
                :src="item"
                :key="index"
                alt
              />
            </div>
          </div>
        </div>
        <!-- 驳回理由 -->
        <div class="reject_reason" v-if="formInfo.state === 2 || formInfo.state === 4">
          <div class="info_left" style="padding:20px 0">
            <p>驳回理由</p>
          </div>
          <div
            class="info_right"
            style="flex:1;display:flex;padding:20px 40px 20px 20px"
          >{{!formInfo.reason?'无':formInfo.reason}}</div>
        </div>
        <!-- 审核意见 -->
        <div class="examine_result">
          <div class="info_left" :style="{padding:formInfo.state === 1?'10px 0':0}">
            <p>审核意见</p>
          </div>
          <div class="info_right" style="flex:1;display:flex;">
            <section
              style="border-right: 1px solid #979797;width: 50%;padding: 20px;display: flex;flex-direction: column;"
            >
              <p style="font-size: 16px;">学校意见：</p>
              <p
                :style="{margin:formInfo.state === 1?'10px 0 0':'15px 0'}"
                style="font-size: 24px;text-align: center;"
              >{{getSchoolAudit}}</p>
              <p
                v-if="formInfo.state > 1"
                style="font-size: 16px;text-align:right"
              >{{formInfo.schoolAuditTime?formInfo.schoolAuditTime.split(' ')[0]:''}}</p>
            </section>
            <section style="width: 50%;padding: 20px;display: flex;flex-direction: column;">
              <p style="font-size: 16px;">省学校体协意见：</p>
              <p
                :style="{margin:formInfo.state === 1?'10px 0 0':'15px 0'}"
                style=" font-size: 24px;text-align: center;"
              >{{getSocietyAudit}}</p>
              <p
                v-if="formInfo.state > 3"
                style="font-size: 16px;text-align:right"
              >{{formInfo.societyAuditTime?formInfo.societyAuditTime:''}}</p>
            </section>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import registerData from "@/assets/json/register.json";
export default {
  props: {
    formInfo: {
      type: Object
    },
    coachList: {
      type: Array
    }
  },
  computed: {
    getRemarkImage() {
      return this.formInfo.remarksImageList.length;
    },
    getSchoolCode() {
      return this.$parent.$children[1].query.code;
    },
    getPolitical() {
      return this.formInfo.political === 1
        ? "团员"
        : this.formInfo.political === 2
        ? "党员"
        : this.formInfo.political === 3
        ? "民主党派"
        : "群众";
    },
    getBloodType() {
      return this.formInfo.bloodType === 1
        ? "A型"
        : this.formInfo.bloodType === 2
        ? "B型"
        : this.formInfo.bloodType === 3
        ? "O型"
        : this.formInfo.bloodType === 4
        ? "AB型"
        : "";
    },
    getSportsLevel() {
      return this.formInfo.sportsLevel === 1
        ? "普通生"
        : this.formInfo.sportsLevel === 2
        ? "体育生"
        : "高水平（特长生等）";
    },
    getEducationalList() {
      let label = "";
      registerData.educationalList.filter(item => {
        if (item.value === this.formInfo.schoolSystem) {
          label = item.label;
        }
      });
      return label;
    },
    getGroup() {
      let label = "";
      registerData.registGroup.filter(item => {
        if (item.value === this.formInfo.group) label = item.label;
      });
      return label;
    },
    getProjectNew() {
      return data => {
        let label = "";
        let arr = [
          ...registerData.sportsProjectList,
          ...registerData.sunshineProject
        ];
        arr.filter(item => {
          if (item.value === data) label = item.label;
        });
        return label;
      };
    },
    getCoachName() {
      let label = "";
      this.coachList.filter(item => {
        if (item.id === this.formInfo.coachId) label = item.name;
      });
      return label;
    },
    getCoachPhone() {
      let phone = "";
      this.coachList.filter(item => {
        if (item.id === this.formInfo.coachId) {
          phone = item.phone;
        } 
      });
      
      return phone;
    },
    getSchoolAudit() {
      return this.formInfo.state <= 1
        ? "待审核"
        : this.formInfo.state === 2
        ? "驳回"
        : "同意";
    },
    getSocietyAudit() {
      return this.formInfo.state <= 3
        ? "待审核"
        : this.formInfo.state === 4
        ? "驳回"
        : "同意";
    }
  }
};
</script>
<style lang="less" scoped>
</style>